export default __webpack_public_path__ + "static/media/report.de423c4c.svg";